import { useCallback } from "react";

import LinkIcon from "@uui/Link01";

import HeaderButton from "@app/analytics/components/reports/HeaderButton";
import * as Events from "@app/analytics/MeetingReport/tracking/events";
import * as ShareUtils from "@app/common/access/ShareReport/utils";
import { toast } from "@app/common/hooks/useToasts";

import CopyButton from "@rui/CopyButton";

const CopyLinkButton = ({
  disabled,
  sessionId,
}: {
  disabled: boolean;
  sessionId: string;
}) => {
  const handleClickCopy = useCallback(() => {
    Events.copyReportUrl();
    toast.success("Copied link to clipboard!");
  }, []);

  return (
    <CopyButton
      onClick={handleClickCopy}
      copyValue={ShareUtils.getReportShareLink(sessionId, "nav")}
      renderIconButton={(buttonProps) => (
        <HeaderButton
          Icon={buttonProps.children || <LinkIcon />}
          disabled={disabled}
          {...buttonProps}
        />
      )}
    />
  );
};

export default CopyLinkButton;
